var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PaperEvaluationsLabel.vue"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0aadb4ca!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PaperEvaluationsLabel.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/domains/event/components/show/labels/PaperEvaluationsLabel.vue
// module id = 670
// module chunks = 2